/* Lavender Farm Simulator — first-visit welcome.
   Shows once, only for a farm that has not started (no XP, no activity). One clear first action:
   "Plant your first row" opens the Field through the game's own button. Never changes the save.
   v319: Huckleberry's own painted portrait instead of a dog emoji; the weather line follows where you farm. */
(function () {
  'use strict';
  if (window.__gllfSimWelcome) return;
  window.__gllfSimWelcome = true;
  var KEY = 'gllf_sim_welcome_v1';

  function seen() { try { return !!localStorage.getItem(KEY); } catch (e) { return true; } }
  function markSeen() { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }
  /* the theme's assets folder, taken from this script's own address */
  function artUrl(id) {
    try {
      if (window.GLLFArt && GLLFArt.url) { var u0 = GLLFArt.url(id); if (u0) return u0; }
      var s = document.querySelector('script[src*="gllf-sim-welcome"]'); if (!s) return '';
      return s.src.split('?')[0].replace(/gllf-sim-welcome[^/]*$/, 'gllf-art-' + id + '.webp');
    } catch (e) { return ''; }
  }

  function show(root, A, force) {
    if (!force && seen()) return;
    var st = {}; try { st = A.state() || {}; } catch (e) {}
    var t = st.time || {};
    if (!force && ((+st.xp) || (t.activityLog || []).length)) { markSeen(); return; }
    var place = (typeof st.place === 'string' ? st.place : (st.place && (st.place.name || st.place.city))) || 'Rockford, MI';
    var dog = artUrl('huckleberry-portrait-three-quarter');
    var el = document.createElement('div');
    el.className = 'gsw';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-labelledby', 'gswTitle');
    el.innerHTML =
      '<div class="gsw__card">' +
        '<div class="gsw__art" aria-hidden="true"><span class="gsw__sun"></span><span class="gsw__rows"><i></i><i></i><i></i></span>' +
          '<span class="gsw__dog' + (dog ? ' has-art' : '') + '">' + (dog ? '<img alt="" src="' + dog + '" width="84" height="84">' : '🐕') + '</span></div>' +
        '<div class="gsw__body">' +
          '<p class="gsw__eyebrow">Huckleberry · your field guide</p>' +
          '<h2 class="gsw__title" id="gswTitle">Welcome to your lavender farm</h2>' +
          '<p class="gsw__lead">It is spring in ' + String(place).replace(/[<>&"]/g, '') + '. The soil is workable and your first field is waiting.</p>' +
          '<ol class="gsw__steps">' +
            '<li><span>Pick a cultivar<small>Hardy English lavender does best here</small></span></li>' +
            '<li><span>Plant your first row<small>Drainage first — lavender hates wet feet</small></span></li>' +
            '<li><span>Watch it grow to bloom<small>Real weather where you farm drives every season</small></span></li>' +
          '</ol>' +
          '<button type="button" class="gsw__go" data-gsw-go><span aria-hidden="true">🌱</span> Plant your first row</button>' +
          '<button type="button" class="gsw__skip" data-gsw-skip>Look around first</button>' +
          '<p class="gsw__meta">Your farm saves automatically.</p>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el);
    var im = el.querySelector('.gsw__dog img');
    if (im) im.addEventListener('error', function () { var d = el.querySelector('.gsw__dog'); if (d) { d.classList.remove('has-art'); d.textContent = '🐕'; } });
    var prev = document.activeElement;
    var go = el.querySelector('[data-gsw-go]');
    setTimeout(function () { go.focus(); }, 50);

    function close(openField) {
      markSeen();
      el.remove();
      document.removeEventListener('keydown', onKey, true);
      if (openField) {
        var b = root.querySelector('[data-v60-route="field"]');
        if (b) { b.click(); } else if (prev && prev.focus) prev.focus();
      } else if (prev && prev.focus) prev.focus();
    }
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(false); }
      if (e.key === 'Tab') {
        var f = el.querySelectorAll('button'); var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    document.addEventListener('keydown', onKey, true);
    go.addEventListener('click', function () { close(true); });
    el.querySelector('[data-gsw-skip]').addEventListener('click', function () { close(false); });
    el.addEventListener('click', function (e) { if (e.target === el) close(false); });
  }
  window.GLLFSimWelcome = { show: function () { var r = document.getElementById('lfg-simulator-root'); if (r && r._lfg) show(r, r._lfg, true); } };

  var tries = 0;
  (function wait() {
    var root = document.getElementById('lfg-simulator-root');
    if (!root && document.readyState === 'complete') return;
    if (root && root._lfg && typeof root._lfg.state === 'function') return setTimeout(function () { show(root, root._lfg, false); }, 600);
    if (++tries < 240) setTimeout(wait, 250);
  })();
})();
